import { type BondRequestExtractionId, Dtos, type SuretyQuoteId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestExtractionQueryKey } from "../bond-request.keys";

export const useFetchAdminBondRequestExtraction = (
	id: BondRequestExtractionId,
	quoteId: SuretyQuoteId,
	options?: { enabled?: boolean },
) => {
	const { get } = useRequest();
	return useQuery({
		queryKey: bondRequestExtractionQueryKey(id, quoteId),
		queryFn: () =>
			get<Dtos.BondRequestExtraction.Get.Response>(
				`/v2/admin/surety/bond-request-extractions/${id}`,
			),
		enabled: options?.enabled ?? true,
	});
};
